module.exports = __webpack_public_path__ + "img/DAVID_CANNON_24-rs.2016dc68.jpg";